import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faTimes, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { BASE_URL } from '../App';
import '../styles/AnnouncementBanner.css';

const AnnouncementBanner = ({ style, auth }) => {
  const [bannerData, setBannerData] = useState(null);
  const [isVisible, setIsVisible] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Wait until student auth is loaded
    if (!auth || typeof auth !== 'object' || auth.id == null) {
      setBannerData(null);
      setIsLoading(true);
      return;
    }

    let cancelled = false;

    const fetchBanner = async () => {
      setIsLoading(true);
      setIsVisible(true);

      try {
        const response = await axios.get(`${BASE_URL}/api/banner`);
        if (cancelled) return;

        if (response.data.success && Array.isArray(response.data.data)) {
          const levels = response.data.data;
          const hasLevel =
            auth.level !== null && auth.level !== undefined && auth.level !== '';
          const userLevelId = hasLevel ? Number(auth.level) : null;

          if (userLevelId === null || Number.isNaN(userLevelId)) {
            setBannerData(null);
            setIsVisible(false);
            return;
          }

          const level = levels.find((l) => Number(l.level_id) === userLevelId);

          if (level && Array.isArray(level.banners) && level.banners.length > 0) {
            setBannerData({ ...level.banners[0], level_name: level.level_name });
            setIsVisible(true);
          } else {
            // No banner for this student's level
            setBannerData(null);
            setIsVisible(false);
          }
        } else {
          setBannerData(null);
          setIsVisible(false);
        }
      } catch (error) {
        console.error('Error fetching banner:', error);
        if (!cancelled) {
          setBannerData(null);
          setIsVisible(false);
        }
      } finally {
        if (!cancelled) setIsLoading(false);
      }
    };

    fetchBanner();

    return () => {
      cancelled = true;
    };
  }, [auth]);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleClick = () => {
    if (bannerData?.link_url) {
      window.open(bannerData.link_url, '_blank');
    }
  };

  if (isLoading || !isVisible || !bannerData) {
    return null;
  }

  return (
    <div className={`announcement-banner ${style ? 'dark-mode' : ''}`}>
      <div className="banner-content">
        <div className="banner-icon">
          <FontAwesomeIcon icon={faBell} />
        </div>
        <div className="banner-text">
          <h3>{bannerData.title}</h3>
          <p>{bannerData.description}</p>
          {bannerData.level_name && (
            <div style={{ fontSize: '1rem', opacity: 0.7, marginTop: 4 }}>
              {bannerData.level_name}
            </div>
          )}
        </div>
        <div className="banner-actions">
          {bannerData.link_url && (
            <button className="banner-link-btn" onClick={handleClick}>
              <FontAwesomeIcon icon={faExternalLinkAlt} />
              <span>شوف التفاصيل</span>
            </button>
          )}
          <button className="banner-close-btn" onClick={handleClose}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      </div>
      <div className="banner-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
        <div className="decoration-circle circle-3"></div>
      </div>
    </div>
  );
};

export default AnnouncementBanner;
